
import getUserInfo from "./getUserInfo";

export default function estimateIncome(infoBaseData,infoDetailsData){
  const userInfo = getUserInfo(app.session.user.id());
  let currentUserType = userInfo.userType()
  let ownerUserType = infoBaseData.userType();
  let category = infoBaseData.category();
  let output = 0;
  let price = infoBaseData.price();
  let zcxx = JSON.parse(infoDetailsData.zcxx());
  let jjxx = JSON.parse(infoDetailsData.jjxx());
  let tdmj = parseFloat(zcxx.option_tdmj);
  let jzmj = parseFloat(zcxx.option_jzmj);
  let synx = zcxx.option_synx;
  let crxs = jjxx.option_crxs;
  let jjbl = parseFloat(jjxx.option_jjbl)/100;
  let ratio = 0;

  if(currentUserType===0){
    if(ownerUserType===null){
      ratio = 0.5;
    }else if(ownerUserType===0){
      ratio = 0.35;
    }
  }else if(currentUserType===9){
    if(ownerUserType===null){
      ratio = 0.5;
    }else if(ownerUserType===0){
      ratio = 0.3;
    }
  }

  if(category==="tdwz"){
    output = (tdmj*price*jjbl)*ratio;
  }else if(category==="jzwz"){
    if(crxs==="cr"){
      output = (jzmj*price*jjbl)*ratio;
    }else if(crxs==="zz"){
      output = (synx*price*jjbl)*ratio;
    }
  }

  return Math.round(output*100)/100;
}
